// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"19":"richtext","736":"vendor"}[chunkId] || chunkId) + "." + {"19":"6e4f6b4b","136":"9a685ddd","147":"30a3603b","219":"4eb4c77d","267":"13c46f0a","416":"c3a9c2c5","482":"98f06c63","736":"90a6d9ec","840":"de1462c9","967":"389cee60"}[chunkId] + ".chunk.js";
};